import * as api from './api';

// Gate debug logging behind NODE_ENV for development use only
const debugLog = (...args: any[]) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(...args);
  }
};

debugLog('[DEBUG reviewCounterService] Module loaded');

const FIRST_POSITIVE_REVIEWS_LIMIT = 50;

/**
 * Get the current count of positive reviews
 * API endpoint: GET /reviews/count
 */
export const getPositiveReviewsCount = async (): Promise<number> => {
  debugLog('[DEBUG getPositiveReviewsCount] Fetching positive reviews count');

  try {
    const response = await api.get<{ count: number }>('/reviews/count');
    debugLog('[DEBUG getPositiveReviewsCount] Current count:', response.count);
    return response.count;
  } catch (error) {
    console.error('[DEBUG getPositiveReviewsCount] Error fetching count:', error);
    return 0;
  }
};

/**
 * Increment the positive reviews counter and return the new count
 * API endpoint: POST /reviews/count/increment
 */
export const incrementPositiveReviewsCount = async (): Promise<number> => {
  debugLog('[DEBUG incrementPositiveReviewsCount] Incrementing positive reviews count');

  try {
    const response = await api.post<{ count: number }>('/reviews/count/increment');
    debugLog('[DEBUG incrementPositiveReviewsCount] New count:', response.count);
    return response.count;
  } catch (error) {
    console.error('[DEBUG incrementPositiveReviewsCount] Error incrementing count:', error);
    return 0;
  }
};

/**
 * Check if a review is among the first 50 positive reviews
 */
export const isAmongFirstPositiveReviews = async (): Promise<boolean> => {
  debugLog('[DEBUG isAmongFirstPositiveReviews] Checking if among first positive reviews');

  try {
    const count = await getPositiveReviewsCount();
    const isAmongFirst = count <= FIRST_POSITIVE_REVIEWS_LIMIT;
    debugLog('[DEBUG isAmongFirstPositiveReviews] Count:', count, 'Is among first:', isAmongFirst);
    return isAmongFirst;
  } catch (error) {
    console.error('[DEBUG isAmongFirstPositiveReviews] Error checking:', error);
    return false;
  }
};

/**
 * Keeping the old function name for backward compatibility
 */
export const isAmongFirstTenPositiveReviews = isAmongFirstPositiveReviews;
